import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: WelcomeListItemModel
})

export class WelcomeListCollection extends Backbone.Collection<WelcomeListItemModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/welcome-list.ts